import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                next: 'next',
                prev: 'prev'
            }
        }
    }

    init() {
        this.swiper = new Swiper(this.el, {
            speed: 800,
            loop: true,
            loopAdditionalSlides: 2,
            parallax: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            }
        });

        console.log(this.swiper);
    }

    next() {
        this.swiper.slideNext();
    }

    prev() {
        this.swiper.slidePrev();
    }
}
